export default __webpack_public_path__ + "static/intro-cond-regular-italic-d4c5fe51fe436e38a6b0088a9385ecaa.woff2";